import { useMutation, UseMutationResult } from '@tanstack/react-query';
import { integrationService } from '../services/integrations.service';

/**
 * Tipo para la respuesta del método `deleteGoogleAuth`.
 */
interface DeleteGoogleAuthResponse {
    _id: string;
}

/**
 * Hook para eliminar la autenticación de Google.
 *
 * @returns La mutation para eliminar la autenticación de Google.
 */
export const useDeleteGoogleAuth = (): UseMutationResult<DeleteGoogleAuthResponse, Error, void> => {
    return useMutation<DeleteGoogleAuthResponse, Error, void>({
        mutationFn: async () => {
            const response = await integrationService.deleteGoogleAuth();
            return response;
        },
        onSuccess: () => {
            localStorage.removeItem('googleAccessToken'); // Elimina el ID de autenticación de Google del almacenamiento local
        },
    });
};
